module.exports = __webpack_public_path__ + "img/nav-logo-awaken.bfca2130.png";